import { Component, inject, ViewEncapsulation, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ClaimsListComponent } from '../claims-list/claims-list.component';
import { CommonModule } from '@angular/common';
import { DashboardSessionDetails, SessionsService } from '@services/sessions.service';
import { map, take } from 'rxjs';
import { AbstractClaimsListDirective, ClaimsListChannelData } from '@directives/abstract-claims-list.directive';
import { Router } from '@angular/router';

@Component({
  selector: 'lv-agent-index',
  templateUrl: 'agent-index.component.html',
  styleUrls: ['agent-index.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule, ClaimsListComponent]
})
export class AgentIndexComponent extends AbstractClaimsListDirective implements OnInit {
  private readonly translate = inject(TranslateService);
  private readonly router = inject(Router);

  onlineIdSessions$: ReturnType<SessionsService['liveIdSessions']>;
  offlineIdSessions$: ReturnType<SessionsService['offlineIdSessions']>;
  retakenSessions$: ReturnType<SessionsService['retakenSessions']>;

  ngOnInit() {
    super.ngOnInit();

    this.onlineIdSessions$ = this.sessionsService
      .liveIdSessions()
      .pipe(map((sessions) => this.filterMySessions(sessions)));

    this.offlineIdSessions$ = this.sessionsService
      .offlineIdSessions()
      .pipe(map((sessions) => this.filterMySessions(sessions)));

    this.retakenSessions$ = this.sessionsService
      .retakenSessions()
      .pipe(map((sessions) => this.filterMySessions(sessions)));
  }

  protected handleChannelData(parsedData: ClaimsListChannelData) {
    super.handleChannelData(parsedData);

    // Online ID session started, handle it accordingly.
    if (parsedData.started) {
      this.handleNewSessionStarted(parsedData);
    }
  }

  /// A new online ID session has been started,
  // we need to refetch the list of online ID sessions and notify the agent.
  private handleNewSessionStarted(parsedData: ClaimsListChannelData) {
    this.sessionsService
      .refetchOnlineIdSessions()
      .pipe(take(1))
      .subscribe((sessions) => {
        const newSession = sessions.find((session) => session.id === parsedData.id);

        if (newSession) {
          this.notify(newSession);
        }
      });
  }

  private notify(session: DashboardSessionDetails) {
    this.translate.get('claims-list.component.notification').subscribe((message) => {
      const notification = this.notifier.notify(message);

      if (notification) {
        notification.addEventListener('click', () => {
          window.focus();

          this.sessionsService.claimSession({ sessionId: session.id }).subscribe({
            next: () => this.router.navigate(['sessions', session.id]),
            error: (error) => console.error('error claiming session', error)
          });
        });
      }
    });
  }
}
